import React, { useState, useEffect, createContext, useContext } from 'react';
import { api } from '../services/apiClient';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if token exists and verify it
    const token = localStorage.getItem('auth_token');
    if (token) {
      api.setToken(token);
      verifyToken();
    } else {
      setLoading(false);
    }
  }, []);

  async function verifyToken() {
    try {
      const data = await api.auth.verify();
      setUser(data.user);
    } catch (error) {
      console.error('Token verification failed:', error);
      api.clearToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  async function signIn(email, password) {
    const data = await api.auth.login(email, password);
    api.setToken(data.token);
    setUser(data.user);
  }

  async function signOut() {
    api.clearToken();
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
